const programs = {
  gaushala: {
    hero: {
      badge: "ગૌ સેવા અને સંરક્ષણ",
      brand: "વૃંદાવન ગીર ગૌશાળા",
      title: "ગીર ગાયોની આદરપૂર્વક સેવા અને સુરક્ષા",
      addressLabel: "સરનામું",
      address:
        "વૃંદાવન ગીર ગૌશાળા, ગોબલજ કોકાકોલા કંપની સામે, કાજીપુરા ગામ . તા.જી.ખેડા-૩૮૭૪૧૧",
      phoneLabel: "મો",
      phone1: "૯૯૭૮૦-૧૫૪૨૪",
      phone2: "૯૦૯૯૯-૩૦૫૮૨",
      phone: "૯૯૭૮૦-૧૫૪૨૪, ૯૦૯૯૯-૩૦૫૮૨",
      subtitle:
        "દેશી ગીર ગાયો, વાછરડાં અને બળદો માટે આજીવન આશ્રય, તાજો લીલો ઘાસચારો, તબીબી સંભાળ અને સુરક્ષિત સ્થાન આપવા માટે સમર્પિત.",
      primaryCta: "ગૌશાળાને સહયોગ આપો",
      secondaryCta: "ગાયનું પ્રાયોજન કરો",
      imageAlt: "સ્વચ્છ પરિસરમાં ગીર ગાયો",
    },
    about: {
      eyebrow: "ગૌશાળા વિશે",
      heading: "જીવ દયા અને કરુણા સભર સંભાળ",
      tagline: "ગૌ સેવા એ માનવસેવાનું પવિત્ર રૂપ છે.",
      body: `ખેડા નિવાસી પૂજ્ય માતૃશ્રી શાંતાબા મૂળચંદજી પરિવાર તરફથી અમદાવાદથી ૧૮ કિલોમીટર દૂર ખેડા નેશનલ હાઇવે પર કાજીપુરા ગામમાં સંસ્થાને ૪૨૦૦ ગજ જમીન ઉદાર દિલથી દાનમાં મળી છે. ત્યાં સંસ્થા દ્વારા વૃંદાવન ગીર ગૌશાળાનું નિર્માણ કાર્ય તા. ૧૪-૭-૨૦૧૭થી પૂરેજોશથી શરૂ કરી દેવામાં આવ્યુ હતુ. જ્યાં ગૌમાતા અને તેમના વંશજોની આજીવન સેવા થઈ શકે, આ જ મુખ્ય ઉદ્દેશ્ય છે.

ગાયના દર્શન અથવા સ્પર્શને આશીર્વાદ માનવો, માતા સમાન પૂજવી અને જે લોકો ગાયમાતાને રાખે છે તેમાં મોટાભાગના ૧૫ થી ૧૭ વર્ષ સુધી દૂધ આપે ત્યાં સુધી ગૌમાતાની સંભાળ રાખે છે, પરંતુ પછી તે વૃદ્ધ થવા પર અથવા બીમાર પડવા પર પાંજરાપોળમાં છોડી દે છે અથવા રસ્તે ખુલ્લી ભટકવા માટે છોડી દે છે. અને આવી ગાયો કતલખાનામાં પહોંચી જાય છે. આજના કલિયુગમાં આ ખૂબ દુઃખની વાત છે, આઘાત અને દુઃખ લાગે, કે આવી હાલત કેમ?

હકીકતમાં આપણે જે દૂધ પીએ છીએ, તે વાછરડાના મોંમાંથી છીનવાયેલું દૂધ છે. ગૌપાલક ખાલી છીનવાયેલું દૂધ વેચે તો વાછરડું શું પીશે? શાસ્ત્રોમાં જણાવેલા સિદ્ધાંતોને અમલમાં લાવતા, ગાયમાતાનો વંશ આગળ ચલાવવો, તેમના દૂધનો પ્રથમ હક્ક વાછરડાને આપવો, પછી બાકીનું દૂધ વૃદ્ધાશ્રમમાં મોકલવું અને નિભાવ ઊભો કરીને જ્યારે ૧૫-૧૭ વર્ષ પછી ગૌ માતા દૂધ ન આપી શકે ત્યારે તેને સંસ્થામાં જ આજીવન રાખવાના સંકલ્પ સાથે ફંડનું આયોજન કરવું, એટલે કે એક ખૂબ જ સુંદર ભાગીરથ કાર્ય સંસ્કૃતિ અને વિરાસતને સંભાળતા કરવું. આવો, માનવજીવનના કલ્યાણકારી કાર્યો સાથે-સાથે અબોલ પશુ અને વિશેષતઃ ગૌમાતા, જેમાં કરોડો દેવતાઓનો વાસ છે, તેની રક્ષા કરીએ.

કંઈક અલગ પ્રકારની ગૌશાળાના દર્શન કરવા તમે અવશ્ય એક વાર પધારો — ગૌશાળાના શાસ્ત્ર સમ્મત સિદ્ધાંતોને સમજીને તમે આ તથ્યને સ્વીકારશો કે વર્તમાનની ગૌશાળા સાથે ભવિષ્યની પાંજરાપોળનો પ્રોજેક્ટ હોવો તે નિતાંત જરૂરી છે, ત્યારે જ આપણે કતલખાનાં અટકાવી શકીશું. ૫૦ ગૌમાતાઓના આગમન સાથે સેવા અને નિર્માણ કાર્ય શરૂ થયું હતું. ૨૦૨૬ માં હાલ ૨૧૦ થી વધુ ગૌ માતા આપણી વૃંદાવન ગીર ગૌ શાળા ની શાન અને આપણી સંસ્કૃતિ નું ગૌરવ વધારી રહી છે.`,
      capacityTitle: "વર્તમાન આશ્રય ક્ષમતા",
      capacityDesc: "હાલમાં ૨૧૦+ થી વધુ ગીર ગાયો, વાછરડાં અને બળદોને આજીવન સંભાળ અને આશ્રય આપવામાં આવે છે.",
      expansionTitle: "ભાવિ વિસ્તરણ યોજના",
      expansionDesc: "અદ્યતન પશુ ચિકિત્સા ક્લિનિક, સોલાર શેડ અને મોટા ચરિયાણ વિસ્તાર સાથે ૫૦૦+ ગાયો માટે ક્ષમતા વધારવાની યોજના.",
    },
    why: {
      eyebrow: "શા માટે સહયોગ આપવો",
      heading: "દરેક ગાય માટે સંપૂર્ણ કલ્યાણ",
      subtitle: "તમારો સહયોગ ગૌમાતા માટે ચોવીસે કલાક સંભાળ, પૌષ્ટિક આહાર અને સન્માન સુનિશ્ચિત કરે છે.",
      card1Title: "દૈનિક પૌષ્ટિક ઘાસચારો",
      card1Desc: "દરરોજ તાજો લીલો ઘાસચારો, સૂકો ચારો અને ઓર્ગેનિક પોષક મિશ્રણ.",
      card2Title: "તબીબી સંભાળ",
      card2Desc: "સમર્પિત પશુ ચિકિત્સક ટીમ, નિયમિત આરોગ્ય તપાસ અને કટોકટી સંભાળ.",
      card3Title: "સુરક્ષિત આશ્રયસ્થાન",
      card3Desc: "ઋતુગત હવામાનથી રક્ષણ અને આરામ માટે વિશાળ, હવાઉજસવાળા શેડ.",
      card4Title: "સ્વચ્છ વાતાવરણ",
      card4Desc: "આરોગ્યપ્રદ પરિસર, પીવાના સ્વચ્છ પાણીની ટાંકીઓ અને રોજિંદી સફાઈ.",
      card5Title: "આજીવન રક્ષણ",
      card5Desc: "વૃદ્ધ, દૂધ ન આપતી, ઇજાગ્રસ્ત અને રક્ષાયેલી ગાયો માટે આજીવન આશ્રય.",
      card6Title: "ગૌ કલ્યાણ",
      card6Desc: "કરુણા, આદર અને પરંપરાગત મૂલ્યોમાં મૂળ ધરાવતી શુદ્ધ ગૌ સેવા.",
    },
    sponsorships: {
      eyebrow: "પ્રાયોજન કાર્યક્રમો",
      heading: "તમારી પ્રાયોજન યોજના પસંદ કરો",
      subtitle: "ઘાસચારો, તબીબી સંભાળ અને ગૌશાળા વિકાસ માટે પારદર્શક સહયોગ.",
      sponsorNow: "પ્રાયોજન કરો",
      popularBadge: "સૌથી લોકપ્રિય",
      decadeBadge: "વિશેષ સેવા",
    },
    stats: {
      eyebrow: "અમારો પ્રભાવ",
      heading: "ગૌ સેવાના મહત્વપૂર્ણ આંકડા",
      cowsSheltered: "આશ્રય મેળવેલ ગાયો",
      dailyMeals: "દૈનિક પૂરો પાડવામાં આવતો આહાર",
      medicalCare: "તબીબી સંભાળ અને આરોગ્ય",
      yearsOfService: "સમર્પિત સેવાના વર્ષો",
    },
    gallery: {
      eyebrow: "ગૌશાળા ગેલેરી",
      heading: "સંભાળ અને આશ્રયની ઝલક",
      item1Title: "વિશ્રામ કરતી ગીર ગાયો",
      item1Desc: "સ્વચ્છ ખુલ્લા શેડમાં આરામ કરતી ગાયો.",
      item2Title: "સવારનો ઘાસચારો",
      item2Desc: "તાજા લીલા ઘાસચારાનું વિતરણ.",
      item3Title: "સ્વચ્છ ગૌશાળા શેડ",
      item3Desc: "વિશાળ અને સુવિધાસભર પરિસર.",
      item4Title: "સમર્પિત સ્વયંસેવકો",
      item4Desc: "પ્રેમપૂર્વક ગૌસેવા કરતા ભક્તો.",
      item5Title: "તબીબી તપાસ",
      item5Desc: "નિયમિત આરોગ્ય અને રસીકરણ તપાસ.",
      item6Title: "રમતાં વાછરડાં",
      item6Desc: "ગૌશાળાના મેદાનમાં આનંદિત વાછરડાં.",
    },
    visit: {
      eyebrow: "ગૌ સેવાનો અનુભવ કરો",
      heading: "ગૌશાળાની મુલાકાત લો",
      subtitle: "ગીર ગાયોની હાજરીમાં શાંતિપૂર્ણ ક્ષણો વિતાવો. ગૌસેવા, ઘાસચારો આપવાનો અને સવાર-સાંજની ગૌ આરતીનો આનંદ અનુભવો.",
      locationTitle: "સ્થળ",
      locationDesc: "જીવનધારા સંસ્થાન કેમ્પસ, વૃંદાવન ગીર ગૌશાળા, ગુજરાત",
      hoursTitle: "મુલાકાતનો સમય",
      hoursDesc: "દરરોજ મુલાકાતીઓ માટે ખુલ્લું: સવારે 7:00 – 11:30 અને સાંજે 4:00 – 6:30",
      planVisit: "મુલાકાતનું આયોજન કરો",
      contactUs: "ગૌશાળા ટીમનો સંપર્ક કરો",
    },
    faq: {
      eyebrow: "પ્રશ્નો છે?",
      heading: "વારંવાર પૂછાતા પ્રશ્નો",
      q1: "હું ગાયનું પ્રાયોજન કેવી રીતે કરી શકું?",
      a1: "ઉપર આપેલી પ્રાયોજન યોજનાઓમાંથી પસંદ કરો અને 'પ્રાયોજન કરો' પર ક્લિક કરી ઓનલાઇન સુરક્ષિત ચૂકવણી પૂર્ણ કરો.",
      q2: "મારા દાનનો ઉપયોગ કેવી રીતે થાય છે?",
      a2: "તમારા દાનની 100% રકમ લીલો-સૂકો ઘાસચારો, તબીબી દવાઓ અને શેડની જાળવણી માટે વપરાય છે.",
      q3: "શું હું ગૌશાળાની મુલાકાત લઈ શકું?",
      a3: "હા! મુલાકાતીઓ અને પરિવારોનું મુલાકાતના કલાકો દરમિયાન ગૌસેવા અને ગૌ આરતી માટે હાર્દિક સ્વાગત છે.",
      q4: "શું દાનની પહોંચ મળે છે?",
      a4: "હા, સફળ ચૂકવણી પછી 80G કર રાહત સાથેની ડિજિટલ પહોંચ તરત જ પ્રાપ્ત થાય છે.",
      q5: "શું હું બહુવિધ વર્ષો કે ખાસ પ્રસંગો માટે પ્રાયોજન કરી શકું?",
      a5: "હા, 2, 5 અને 10 વર્ષના કાર્યક્રમો ઉપલબ્ધ છે. આપ જન્મદિવસ કે પુણ્યતિથિ જેવા પ્રસંગોએ પણ પ્રાયોજન કરી શકો છો.",
      q6: "ગૌશાળા વિકાસ ફંડ શું છે?",
      a6: "વિકાસ ફંડ (₹9,000) શેડ નિર્માણ, પાણીની ટાંકીઓ અને પશુ દવાખાનાની સુવિધાઓના વિસ્તરણમાં સીધો ઉપયોગ થાય છે.",
    },
    cta: {
      heading: "ગૌ સેવાનો ભાગ બનો",
      subtitle: "ગીર ગાયોની સંભાળ, પોષણ અને આજીવન રક્ષણ માટે આપનું યોગદાન આપો.",
      sponsorNow: "પ્રાયોજન કરો",
    },
  },
  gruhUdhyog: {
    hero: {
      badge: "100% શુદ્ધ અને ગૃહનિર્મિત",
      brand: "મહિલા ઉત્કર્ષ કેન્દ્ર – સદગુણા ગૃહ ઉદ્યોગ",
      title: "પ્રેમ અને પરંપરાથી બનેલી વાનગીઓ અને હસ્તકળા",
      subtitle: "વડીલો અને મહિલા સ્વસહાય જૂથો દ્વારા તૈયાર કરાયેલ પરંપરાગત નાસ્તા, અથાણાં, મસાલા, મીઠાઈઓ અને સુશોભન વસ્તુઓ. 100% આવક વડીલોની સેવા માટે.",
      primaryCta: "ઉત્પાદનો જુઓ",
      secondaryCta: "અમારું લક્ષ્ય",
    },
    about: {
      eyebrow: "ગૃહ ઉદ્યોગ વિશે",
      heading: "મહિલા ઉત્કર્ષ કેન્દ્ર – સદગુણા ગૃહ ઉદ્યોગ",
      subheading: "(સ્વ. શ્રી સદ્ગુણા સ્નેહલ ગોસલિયા)",
      tagline: "મહિલાઓને આત્મનિર્ભર બનાવી રોજગારી અને ગૌરવપૂર્ણ જીવન પૂરું પાડવાની પહેલ.",
      body: `મહિલાઓને આત્મનિર્ભર બનાવવાના પુણ્ય હેતુએ બેરોજગાર બહેનોને રોજગારી મળી રહે તે માટે વર્ષ ૨૦૧૧માં મહિલા ઉત્કર્ષ કેન્દ્રની સ્થાપના સ્વ. શ્રી સદ્ગુણા સ્નેહલ ગોસલિયા (કમિટી મેમ્બર) અને માનવ સેવા સમાજ કલ્યાણ ટ્રસ્ટના સહયોગથી કરવામાં આવી. મહિલાઓ ખાખરા, પાપડ અને નમકીન વગેરેનું ઉત્પાદન કરે છે, જે રોજ વેચાઈ જાય છે.

પ્રતિદિન ૨૦૦ કિલોનું ઉત્પાદન અને વેચાણ તેની સફળતાનો પ્રમાણ માત્ર છે. રોજગારી કરતી બહેનોને પ્રતિ ત્રણ માસે ફ્રી અનાજ સહાય અને તેમના બાળકોને શૈક્ષણિક સહાય પણ કરવામાં આવે છે. મહિલાઓને આત્મનિર્ભર બનાવવો એ અમારો મુખ્ય ઉદ્દેશ્ય છે.`,
      feature1Title: "દૈનિક ૨૦૦ કિલો સ્વાદિષ્ટ ઉત્પાદન",
      feature1Desc: "ખાખરા, પાપડ અને નમકીનનું શુદ્ધ અને તાજું દૈનિક ઉત્પાદન અને વેચાણ.",
    },
    categories: {
      all: "બધા ઉત્પાદનો",
      snacks: "ગૃહનિર્મિત નાસ્તો",
      pickles: "શુદ્ધ અથાણાં",
      spices: "દળેલા મસાલા",
      sweets: "પરંપરાગત મીઠાઈઓ",
      handicrafts: "હસ્તકળા શિલ્પ",
    },
    catalog: {
      eyebrow: "અમારા ઉત્પાદનો",
      heading: "અમારું ગૃહનિર્મિત કલેક્શન જુઓ",
      subtitle: "સ્વચ્છ વાતાવરણમાં શુદ્ધ સામગ્રી અને પરંપરાગત રેસિપી સાથે નિર્મિત.",
      note: "શું તમે તહેવારો અથવા બલ્ક ઓર્ડર કરવા માંગો છો? ",
      contactUs: "અમારી ટીમનો સંપર્ક કરો",
    },
    featured: {
      eyebrow: "લોકપ્રિય વાનગીઓ",
      heading: "સૌથી વધુ પસંદ કરાયેલ વાનગીઓ",
      subtitle: "ગુજરાત અને ભારતના હજારો પરિવારો દ્વારા પસંદ કરાયેલ.",
    },
    artisans: {
      eyebrow: "સ્વાવલંબન અને ગૌરવ",
      heading: "અમારા વડીલ કલાકારોની કહાની",
      subtitle: "દરેક વાનગી અને વસ્તુ ગૌરવ અને પ્રેમનું પ્રતીક છે.",
      quote: "આ પરંપરાગત વાનગીઓ બનાવવાથી અમને રોજ આનંદ, ભાઈચારો અને ગૌરવની અનુભૂતિ થાય છે.",
      a1Name: "મંજુલા બેન શાહ",
      a1Craft: "ખાખરા અને ફરસાણ નિષ્ણાત",
      a1Years: "12 વર્ષથી સેવા",
      a2Name: "સરોજ બેન મહેતા",
      a2Craft: "અથાણાં અને છૂંદા સ્પેશિયાલિસ્ટ",
      a2Years: "9 વર્ષથી સેવા",
      a3Name: "લીલાવતી બેન જોશી",
      a3Craft: "મસાલા અને મીઠાઈ નિષ્ણાત",
      a3Years: "15 વર્ષથી સેવા",
    },
    by: "દ્વારા",
    cta: {
      heading: "વડીલોના ગૌરવને સપોર્ટ કરો અને શુદ્ધ સ્વાદ માણો",
      body: "આજે જ ઓનલાઇન ઓર્ડર કરો અથવા તહેવાર માટે બલ્ક ઓર્ડર બુક કરો. 100% રકમ વડીલોના રહેઠાણ અને સારવારમાં વપરાય છે.",
      support: "સપોર્ટ કરો",
      order: "બલ્ક / તહેવાર ઓર્ડર કરો",
    },
    franchise: {
      badge: "ફ્રેન્ચાઇઝી તક",
      title: "શું તમે ગૃહ-ઉદ્યોગ",
      titleHighlight: "ફ્રેન્ચાઇઝી શોધી રહ્યા છો?",
      description:
        "ગૃહ-ઉદ્યોગમાં તમારા રસને એક સુવર્ણ તકમાં ફેરવો. ફ્રેન્ચાઇઝી પાર્ટનર તરીકે અમારી સાથે જોડાવો અને એવા અભિયાનનો ભાગ બનો જે ઘરેલું ઉદ્યોગોને પ્રોત્સાહન આપે છે અને પરિવારો માટે રોજગારીનું સર્જન કરે છે.",
      feature1: "ગૃહ આધારિત ઉદ્યોગોને સહાય",
      // feature2: "રોજગારની તકોનું સર્જન",
      feature2: "મજબૂત સમુદાયનું નિર્માણ",
      badgeScript: "શરૂ કરો • આગળ વધો • યોગદાન આપો",
      cta: "પૂછપરછ કરો",
      modalTitle: "ગૃહ-ઉદ્યોગ ફ્રેન્ચાઇઝી પૂછપરછ",
      modalSubtitle:
        "જીવનધારા ગૃહ-ઉદ્યોગ સાથે જોડાઈને વડીલો અને ગૃહ કારીગરોને આત્મનિર્ભર બનાવો.",
      fullName: "પૂરું નામ",
      phoneNumber: "ફોન નંબર",
      email: "ઈમેઇલ સરનામું",
      cityLocation: "શહેર / વિસ્તાર",
      experience: "વ્યાપાર અનુભવ / પૃષ્ઠભૂમિ",
      message: "સંદેશ / વિશેષ વિગત",
      submit: "ફ્રેન્ચાઇઝી પૂછપરછ મોકલો",
      submitting: "મોકલી રહ્યા છીએ…",
      successTitle: "પૂછપરછ મળી ગઈ છે!",
      successMessage:
        "તમારા રસ બદલ આભાર. અમારી ફ્રેન્ચાઇઝી ટીમ ટૂંક સમયમાં તમારો સંપર્ક કરશે.",
      callDirect: "અથવા અમારી હેલ્પલાઇન દ્વારા સીધો સંપર્ક કરો:",
    },
    employment: {
      badge: "રોજગારીની તકો",
      title: "શું તમે સન્માનપૂર્વક",
      titleHighlight: "રોજગારી મેળવવા માંગો છો?",
      description:
        "જીવનધારા ગૃહ-ઉદ્યોગ પરિવાર સાથે જોડાવો. અમે મહિલાઓ, વડીલો અને આત્મનિર્ભર બનવા માંગતા લોકો માટે સન્માનજનક, ગૃહ-આધારિત અને કૌશલ્યલક્ષી રોજગારીની ઉત્તમ તકો પૂરી પાડીએ છીએ.",
      feature1: "ગૌરવપૂર્ણ અને સુરક્ષિત વાતાવરણ",
      feature2: "કૌશલ્ય મુજબ સરળ કામગીરી",
      feature3: "નિયમિત અને યોગ્ય વળતર",
      badgeScript: "કમાવો • ગૌરવ મેળવો • આત્મનિર્ભર બનો",
      cta: "રોજગારી માટે અરજી કરો",
      modalTitle: "રોજગારી મેળવવા માટેની અરજી",
      modalSubtitle:
        "જીવનધારા ગૃહ-ઉદ્યોગ સાથે જોડાઈને સન્માનપૂર્વક આજીવિકા મેળવો.",
      fullName: "નામ",
      fullNamePlaceholder: "દા.ત. મીનાબેન પટેલ",
      phoneNumber: "મોબાઇલ નંબર",
      phoneNumberPlaceholder: "+91 98765 43210",
      lookingForEmployment: "રોજગારી મેળવવા માંગો છો?",
      lookingYes: "હા, હું રોજગારી મેળવવા માંગુ છું",
      lookingYesDesc: "કારીગરી, નાસ્તા પેકિંગ, રસોઈકામ અથવા અન્ય સહાય",
      lookingNo: "ના, અન્ય પૂછપરછ",
      lookingNoDesc: "પરિવારજન માટે અથવા સામાન્ય માહિતી",
      additionalDetails: "વધારાની વિગતો (Additional Details)",
      additionalDetailsPlaceholder:
        "તમારા કૌશલ્ય, મનપસંદ કામ (જેમ કે નાસ્તા બનાવવું, પેકિંગ, સહાયક કામ) અથવા અન્ય વિગતો જણાવો...",
      submit: "અરજી મોકલો",
      submitting: "મોકલી રહ્યા છીએ…",
      successTitle: "અરજી સફળતાપૂર્વક મળી ગઈ!",
      successMessage:
        "તમારી વિગતો બદલ આભાર. અમારી ગૃહ-ઉદ્યોગ ટીમ યોગ્ય રોજગારી માટે ટૂંક સમયમાં તમારો સંપર્ક કરશે.",
      callDirect: "અથવા અમારી હેલ્પલાઇન દ્વારા સીધો સંપર્ક કરો:",
    },
  },
  tiffinSeva: {
    hero: {
      eyebrow: "જીવનધારા વૃદ્ધાશ્રમની પહેલ",
      title: "ભગવાન મહાવીર સીનિયર સિટીઝન ટિફિન સેવા",
      subtitle:
        "ઘરે રહેતા વરિષ્ઠ નાગરિકો અને જરૂરિયાતમંદ પરિવારોના ઘર આંગણે ગરમ, પૌષ્ટિક સાત્ત્વિક ભોજન પહોંચાડવું.",
    },
    poem: {
      title: "ભગવાન મહાવીર સીનિયર સિટીઝન ટિફિન સેવા",
      intro: "આ માત્ર ટિફિન નથી... પણ એક મા ની મમતા છે ❤️",
      lines: [
        "એક થાળી દાળ ભાત નથી પણ",
        "એકલા રહેતા વડીલોની આંખમાંથી વહેતાં આંસુ લૂછવાનો પ્રયત્ન છે!",
        "ભગવાન મહાવીર સિનિયર સિટીઝન ટિફિન સેવા એ માત્ર જન સેવાનું કાર્ય નથી,",
        "પણ એક ધબકતી લાગણી છે, કરુણા છે, અને જન સેવા માટે નું નિ:સ્વાર્થ સમર્પણ છે ❤️",
        "સ્વપ્નદ્રષ્ટા અને કરુણામૂર્તિ એંવા અમારા મેનેજિંગ ટ્રસ્ટી શ્રી સંદીપભાઈ શાહ નો એક સુકૃત વિચાર...કે",
        "\"આપણા અમદાવાદમાં કોઈ જરૂરિયાતમંદ વડીલ ભૂખ્યું ના સૂવું જોઈએ!\"",
        "ઘરે કોઈ બનાવવાવાળું નથી, સંતાનો દૂર છે, ઉંમર થઈ છે...",
        "પણ ચિંતા ના કરો, અમે છીએ !!",
        "રોજ ગરમ,શુધ્ધ,સાત્વિક અને પ્રેમથી બનેલું ભોજન તમારા ઘરના દરવાજે પહોંચશે !",
        "આ સેવા નથી, પણ અમારી જવાબદારી છે.",
        "આપની એકલતામાં સાથ આપવાનું અમારુ વચન છે!",
        "જીવનધારા વૃદ્ધાશ્રમ પરિવાર જો દીકરો બનીને આપનો દરવાજો ખખડાવશે તો ખોલશો ને!! ☺️",
        "જો તમારી આસપાસ કોઈ એવા વડીલ હોય જેને આ ટિફિન સેવાની જરૂર હોય તો અમને અચૂક થી જાણ કરવા વિનંતિ."
      ],
      authorLabel: "લેખક",
      authorName: "Dhruti Dwivedi",
      foundation: "જીવનધારા વૃદ્ધાશ્રમ પરિવાર",
      readMore: "વધુ વાંચો",
      close: "બંધ કરો"
    },
    about: {
      eyebrow: "પહેલ વિશે",
      title: "ટિફિન સેવા વિશે",
      tagline:
        "નિઃસ્વાર્થ રસોઈ, ભક્તિ અને કરુણા દ્વારા મન, શરીર અને આત્માનું પોષણ.",
      body:
        "પ.પૂ. મુનિશ્રી હંસબોધિવિજયજી મ. સાહેબની પ્રેરણા તથા પ.પૂ. મુનિશ્રી મહાબોધિવિજયજી મ. સાહેબના સહકાર તથા આશીર્વાદથી સિનિયર સિટીઝન ટિફિન સેવા ૧૪-૧-૨૦૧૪ ઉત્તરાયણ પર્વના દિવસથી શરૂ કરવામાં આવી.\n\nજેના અંતર્ગત વૃદ્ધાશ્રમના આસપાસના ૫ કિ.મી. વિસ્તારમાં વસતા આર્થિક રીતે પછાત, નિઃસંતાન, પથારીવશ, અંધ, અથવા જરૂરિયાતવાળા સિનિયર સિટીઝનને નિઃશુલ્ક, અથવા જે ભરી શકે તેમને માત્ર ૧૦ રૂપિયા ટોકન દરે ટિફિન પૂરું પાડવામાં આવે છે.\n\nસશક્ત વ્યક્તિ પોતે ટિફિન લઈ જાય છે અને અશક્તને ઘરે ટિફિન પહોંચાડવામાં સંસ્થા પ્રતિદિન સેવા આપે છે. વર્તમાનમાં ૯૦ થી વધુ ટિફિનની પ્રતિદિન વ્યવસ્થા કરવામાં આવે છે.\n\nઆશ્રમનિવાસી વડીલો માટે જે ભોજન બને છે તે જ ભોજન વ્યવસ્થા ટિફિનમાં રહે છે. અતઃ આ સુંદર યોજનામાં આપ લાભ લેવાનું ચૂકશો નહીં, એ અમારું નમ્ર નિવેદન છે.",
      applyBtn: "ટિફિન સેવા માટે અરજી કરો",
      donateBtn: "સહયોગ અને દાન",
    },
    specialization: {
      badge: "અમારી મુખ્ય શક્તિઓ",
      title: "ટિફિન સેવા વિશેષતાઓ",
      desc: "રોજિંદી સમયસર ડિલિવરી, પવિત્ર રાંધણ ધોરણો અને ઉત્કૃષ્ટ સ્વચ્છતા સાથે તૈયાર.",
      items: {
        jainFood: {
          title: "૧૦૦% જૈન ભોજન",
          tagline: "શુદ્ધ સાત્ત્વિક અને પવિત્ર",
          desc: "જૈન આહારના સિદ્ધાંતોનું પાલન કરીને શુદ્ધ, પવિત્ર રસોડામાં ડુંગળી, લસણ અથવા કંદમૂળ વગર સખત રીતે તૈયાર કરવામાં આવે છે.",
          badge: "૧૦૦% જૈન",
        },
        delivery: {
          title: "સમયસર ડિલિવરી",
          tagline: "સમયસર ઘર આંગણે સેવા",
          desc: "બપોરના ભોજન માટે ૧૨:૩૦ પહેલા દૈનિક ડિલિવરી, જેથી ભોજન ગરમ અને તાજું માણી શકાય.",
          badge: "દૈનિક સમયસર",
        },
        regular: {
          title: "નિયમિત દૈનિક ટિફિન",
          tagline: "૩૬૫ દિવસ અવિરત",
          desc: "વર્ષ દરમિયાન શૂન્ય વિક્ષેપ સાથે વિશ્વસનીય દૈનિક સેવા, જેથી વરિષ્ઠ નાગરિક અને આશ્રિત પરિવારોને ક્યારેય ગરમ ભોજનની ચિંતા ન થાય.",
          badge: "૩૬૫ દિવસ સક્રિય",
        },
        authentic: {
          title: "શ્રેષ્ઠ અને અસલી જૈન સ્વાદ",
          tagline: "પૌષ્ટિક અને પરંપરાગત",
          desc: "પ્રેમ અને કાળજીપૂર્વક બનેલી ગરમ ફુલેલી રોટલી, સુગંધિત ગુજરાતી દાળ, બાસમતી ભાત અને ઋતુગત શાક.",
          badge: "અસલી સ્વાદ",
        },
      },
    },
    registration: {
      senior: {
        badge: "૬૦ વર્ષથી વધુ",
        tag: "મફત / ટ્રસ્ટ સહાયિત",
        title: "વરિષ્ઠ નાગરિક નોંધણી",
        desc: "નિયમિત સાત્ત્વિક ભોજનની જરૂરિયાતવાળા વરિષ્ઠ નાગરિક અને દંપતીઓ (૬૦+ વર્ષ) માટે વિશેષ સમર્પિત.",
        bullet1: "શૂન્ય નોંધણી ફી (ટ્રસ્ટ દ્વારા સંપૂર્ણ સહાયિત)",
        bullet2: "એડમિન વેરિફિકેશન અને મંજૂરીને આધીન",
        bullet3: "ગરમ સાત્ત્વિક બપોરનું ભોજન ઘર આંગણે",
        btn: "અરજી કરો (૬૦ વર્ષથી વધુ)",
      },
      general: {
        badge: "૬૦ વર્ષથી ઓછી",
        tag: "ફી: ₹૧૦૦",
        title: "સામાન્ય / જરૂરિયાતમંદ નોંધણી",
        desc: "૬૦ વર્ષથી ઓછી ઉંમરના વ્યક્તિઓ, દિવ્યાંગો અથવા ભોજન સહાયની જરૂરિયાતવાળા પરિવારો માટે.",
        bullet1: "માત્ર ₹૧૦૦ ની નજીવી નોંધણી ફી",
        bullet2: "દસ્તાવેજ ચકાસણી સાથે ઝડપી પ્રક્રિયા",
        bullet3: "શુદ્ધ શાકાહારી સાત્ત્વિક ભોજન દરરોજ વિતરિત",
        btn: "અરજી કરો (૬૦ વર્ષથી ઓછી - ₹૧૦૦ ફી)",
      },
    },
    eligibility: {
      badge: "કોણ લાભ મેળવી શકે?",
      title: "ટિફિન સેવા માટે યોગ્યતા",
      cards: {
        senior: {
          title: "વરિષ્ઠ નાગરિક (૬૦+ ઉંમર)",
          desc: "એકલા રહેતા વડીલો, રસોઈ કરવામાં અસમર્થ, અથવા દૈનિક સાત્ત્વિક આહારની જરૂરિયાત વાળા. એડમિન ચકાસણી પછી ટ્રસ્ટના સહયોગથી સંપૂર્ણ સબસિડીયુક્ત.",
          tag: "મફત / ટ્રસ્ટ પ્રાયોજિત",
        },
        general: {
          title: "સામાન્ય નોંધણી (<૬૦ વર્ષ)",
          desc: "ઘર આંગણે સાત્ત્વિક ભોજન સહાયની જરૂરિયાત વાળા જરૂરિયાતમંદ વ્યક્તિઓ, પરિવારો અથવા દિવ્યાંગો.",
          tag: "ફી: ₹૧૦૦",
        },
        divyang: {
          title: "દિવ્યાંગ (વિકલાંગ વ્યક્તિઓ)",
          desc: "શારીરિક રીતે પડકારરૂપ વ્યક્તિઓ કે જેમને દરરોજ ગરમ પૌષ્ટિક ભોજનની ઘરે પહોંચાડવાની જરૂર હોય.",
          tag: "ઘરે ડિલિવરી",
        },
      },
    },
    howItWorks: {
      badge: "સરળ ૪-પગલાંની પ્રક્રિયા",
      title: "ટિફિન સેવા કેવી રીતે કામ કરે છે",
      steps: {
        step1: {
          title: "કેટેગરી પસંદ કરો",
          desc: "૬૦ વર્ષથી વધુ (વરિષ્ઠ સેવા) અથવા ૬૦ વર્ષથી નીચે (₹૧૦૦ ફી) પસંદ કરો.",
        },
        step2: {
          title: "વિગતો ભરો",
          desc: "અરજદાર, પરિવારની વિગતો, નાણાકીય માહિતી અને ઓળખ કાર્ડ અપલોડ કરો.",
        },
        step3: {
          title: "ચકાસણી અને મંજૂરી",
          desc: "અમારા કો-ઓર્ડિનેટર અરજીની સમીક્ષા કરે છે અને ડિલિવરી ઝોનની ચકાસણી કરે છે.",
        },
        step4: {
          title: "ટિફિન ડિલિવરી શરૂ",
          desc: "તાજું ગરમ સાત્ત્વિક ભોજન દરરોજ સીધું તમારા ઘર આંગણે પહોંચાડવામાં આવે છે.",
        },
      },
    },
    modal: {
      title: "ટિફિન સેવા માટે અરજી કરો",
      subtitle: "પ્રેમ અને ભક્તિ સાથે તૈયાર કરાયેલ તાજું, આરોગ્યપ્રદ અને પૌષ્ટિક સાત્ત્વિક ભોજન ઘર આંગણે.",
      badgeSenior: "૬૦ વર્ષથી વધુ (વરિષ્ઠ સેવા)",
      badgeGeneral: "૬૦ વર્ષથી ઓછી (₹૧૦૦ ફી)",
      categoryStep: {
        heading: "નોંધણી કેટેગરી પસંદ કરો",
        desc: "ટિફિન સેવા નોંધણી ચાલુ રાખવા માટે લાભાર્થીની ઉંમર જૂથ પસંદ કરો.",
        seniorBadge: "ટ્રસ્ટ સહાયિત",
        seniorTitle: "૬૦ વર્ષથી વધુ (વરિષ્ઠ નાગરિક)",
        seniorDesc: "એકલા રહેતા અથવા રસોઈ કરવામાં અસમર્થ વરિષ્ઠ નાગરિક અને વડીલ દંપતી માટે વિશેષ સમર્પિત.",
        seniorFee: "મફત / સબસિડીયુક્ત",
        seniorNote: "એડમિન મંજૂરીને આધીન",
        generalBadge: "ફી: ₹૧૦૦",
        generalTitle: "૬૦ વર્ષથી ઓછી (સામાન્ય / જરૂરિયાતમંદ)",
        generalDesc: "૬૦ વર્ષથી ઓછી ઉંમરના વ્યક્તિઓ, દિવ્યાંગો અથવા આર્થિક રીતે નબળા પરિવારો માટે.",
        generalFee: "ફી: ₹૧૦૦",
        generalNote: "તત્કાળ પ્રક્રિયા",
        qualityNote: "તમામ ભોજન સ્વચ્છ સાત્ત્વિક રસોડાની સુવિધાઓમાં કડક ગુણવત્તા અને સ્વચ્છતા ધોરણો હેઠળ તૈયાર કરવામાં આવે છે.",
      },
      successStep: {
        seniorTitle: "અરજી સબમિટ! એડમિન મંજૂરીની રાહ જોઈ રહ્યા છીએ.",
        seniorDesc: "અમારા ટિફિન સેવા કો-ઓર્ડિનેટર અરજીની વિગતો, રહેઠાણ અને ઓળખ દસ્તાવેજો ચકાસશે. મંજૂરી થતાં જ અમે તમારો સંપર્ક કરીશું:",
        seniorDescEnd: "",
        generalFeeLabel: "નોંધણી ફી: ₹૧૦૦",
        generalTitle: "ટિફિન સેવા અરજી સફળ!",
        generalDesc: "ટિફિન સેવા (૬૦ વર્ષથી ઓછી) માટે તમારી નોંધણી ₹૧૦૦ ની ફી સાથે નોંધાઈ ગઈ છે.",
        generalDescEnd: " ડિલિવરી સૂચિ મુજબ શરૂ થશે.",
        summaryTitle: "અરજી સારાંશ",
        summaryAbove60: "૬૦ વર્ષથી વધુ",
        summaryBelow60: "૬૦ વર્ષથી ઓછી",
        labelApplicant: "અરજદાર",
        labelMobile: "મોબાઇલ",
        labelTiffinPeriod: "ટિફિન સમયગાળો",
        labelFeeStatus: "ફી સ્થિતિ",
        feeFree: "મફત (ટ્રસ્ટ પ્રાયોજિત)",
        feePaid: "₹૧૦૦ (નોંધણી ફી)",
        immediate: "તત્કાળ",
        to: "થી",
        close: "બંધ કરો",
        thankYou: "ધન્યવાદ,",
      },
      formStep: {
        switchCategory: "કેટેગરી બદલો",
        categoryLabel: "કેટેગરી:",
        seniorCategoryText: "૬૦ વર્ષથી વધુ (વરિષ્ઠ નાગરિક)",
        generalCategoryText: "૬૦ વર્ષથી ઓછી",
        registrationFeesBadge: "નોંધણી ફી: ₹૧૦૦",
        trustSponsoredBadge: "ટ્રસ્ટ સહાયિત (એડમિન મંજૂરી)",
        section1Title: "અરજદારની વિગતો",
        tiffinStartDate: "ટિફિન શરૂ થવાની તારીખ",
        tiffinEndDate: "ટિફિન સમાપ્ત તારીખ (વૈકલ્પિક)",
        endDatePlaceholder: "ચાલુ ટિફિન માટે ખાલી છોડો",
        name: "નામ",
        namePlaceholder: "લાભાર્થી / અરજદારનું પૂરું નામ દાખલ કરો",
        address: "સરનામું",
        addressPlaceholder: "ઘર / ફ્લેટ નં., સોસાયટી / શેરી, લેન્ડમાર્ક, શહેર અને પિનકોડ",
        age: "ઉંમર",
        agePlaceholderSenior: "દા.ત. ૬૮ (૬૦+ ફરજિયાત)",
        agePlaceholderGeneral: "દા.ત. ૪૨",
        gender: "લિંગ",
        male: "પુરૂષ",
        female: "સ્ત્રી",
        other: "અન્ય",
        dateOfBirth: "જન્મ તારીખ",
        mobileNo: "મોબાઇલ નં.",
        section2Title: "કૌટુંબિક વિગતો",
        section2Desc: "પરિવારના સભ્યો અને ઘરની વિગતો",
        addFamilyMember: "સભ્ય ઉમેરો",
        colName: "નામ",
        colAge: "ઉંમર",
        colRelationship: "સંબંધ",
        colOccupation: "વ્યવસાય",
        colMobile: "મોબાઇલ",
        colAction: "ક્રિયા",
        section3Title: "નાણાકીય અને અન્ય વિગતો",
        monthlyIncome: "પરિવારની માસિક આવક",
        monthlyIncomePlaceholder: "દા.ત. ₹10,000 / મહિનો અથવા શૂન્ય",
        tiffinRecipient: "ટિફિન લાભાર્થી",
        tiffinRecipientPlaceholder: "દા.ત. સ્વ, વૃદ્ધ માતા-પિતા, દિવ્યાંગ",
        referenceName: "સંદર્ભ આપનારનું નામ",
        referenceNamePlaceholder: "ડૉક્ટર / પડોશી / ટ્રસ્ટ ટ્રસ્ટી / સામાજિક કાર્યકર",
        referenceMobile: "સંદર્ભ આપનારનો મોબાઇલ નં.",
        referenceAddress: "સંદર્ભ આપનારનું સરનામું",
        referenceAddressPlaceholder: "સરનામું / વિસ્તાર",
        referenceOccupation: "સંદર્ભ આપનારનો વ્યવસાય",
        referenceOccupationPlaceholder: "દા.ત. ડૉક્ટર, વેપારી, સામાજિક કાર્યકર",
        tiffinArrangement: "ટિફિન વ્યવસ્થાની વિગત",
        tiffinArrangementPlaceholder: "દા.ત. ફક્ત લંચ, ફક્ત ડિનર, બંને ભોજન, ડિલિવરી સમય...",
        deliveryOptionsLabel: "ડિલિવરી વિકલ્પ",
        deliveryOptionsDesc: "તમારા ટિફિન મેળવવાની રીત પસંદ કરો",
        deliverySelf: "સ્વયં (Self)",
        deliverySelfBadge: "કેન્દ્રથી",
        deliverySelfDesc: "આશ્રમ કેન્દ્ર પરથી જાતે ટિફિન મેળવો",
        deliveryHome: "હોમ ડિલિવરી (Home Delivery)",
        deliveryHomeBadge: "ઘર આંગણે",
        deliveryHomeDesc: "તમારા નોંધાયેલા ઘરના સરનામે ડિલિવરી",
        deliveryPorter: "પોર્ટર (Porter)",
        deliveryPorterBadge: "કુરિયર",
        deliveryPorterDesc: "પોર્ટર સેવા દ્વારા ડિલિવરી વ્યવસ્થા",
        porterAddressLabel: "પોર્ટર ડિલિવરી સરનામું",
        porterAddressPlaceholder: "લેન્ડમાર્ક સાથે પોર્ટર ડ્રોપ-ઓફનું સરનામું દાખલ કરો...",
        sameAsApplicantAddress: "અરજદારના સરનામા મુજબ જ (Same as above)",
        reasonForTiffin: "ટિફિન આપવાનું કારણ",
        reasonPlaceholder: "પરિસ્થિતિ સ્પષ્ટ કરો: દા.ત. એકલા રહેતા વૃદ્ધ, રસોઈ અસમર્થ, આર્થિક મુશ્કેલી...",
        section4Title: "ઓળખ પ્રમાણ",
        selectIdDocs: "ઉપલબ્ધ ઓળખ દસ્તાવેજ પસંદ કરો:",
        aadhaar: "આધાર કાર્ડ",
        rationCard: "રેશન કાર્ડ",
        voterId: "ચૂંટણી કાર્ડ / મતદાર ઓળખ",
        uploadLabel: "ઓળખ દસ્તાવેજ અપલોડ (PDF / ફોટો)",
        uploadPrompt: "આધાર / રેશન / મતદાર ઓળખ અપલોડ કરો",
        changeDoc: "અલગ દસ્તાવેજ પસંદ કરો",
        uploadPhotoLabel: "અરજદારનો ફોટો અપલોડ કરો (JPG / PNG)",
        uploadPhotoPrompt: "ફોટો અપલોડ કરો",
        changePhoto: "અલગ ફોટો પસંદ કરો",
        back: "પાછળ",
        cancel: "રદ કરો",
        submitting: "સબમિટ થઈ રહ્યું છે...",
        submitSenior: "એડમિન મંજૂરી માટે સબમિટ કરો",
        submitGeneral: "અરજી સબમિટ (₹૧૦૦ ચૂકવો)",
      },
      errors: {
        nameRequired: "અરજદારનું નામ દાખલ કરો",
        mobileRequired: "મોબાઇલ નંબર દાખલ કરો",
        addressRequired: "સરનામું દાખલ કરો",
        photoRequired: "કૃપા કરીને અરજદારનો ફોટો અપલોડ કરો",
        porterAddressRequired: "કૃપા કરીને પોર્ટર ડિલિવરી સરનામું દાખલ કરો",
        submitError: "અરજી સબમિટ કરવામાં ભૂલ. ફરી પ્રયાસ કરો.",
        genericError: "કંઈ ખોટું ગયું. ફરી પ્રયાસ કરો.",
      },
      toastSenior: "તમારી અરજી સબમિટ થઈ. એડમિન મંજૂરીની રાહ જુઓ.",
      toastGeneral: "ટિફિન સેવા અરજી સફળ. ફી: ₹૧૦૦.",
    },
    toast: {
      error: "સબમિટ કરી શકાયું નહીં",
      success: "વિનંતી સબમિટ થઈ. અમારી ટીમ જલ્દી જ તમારો સંપર્ક કરશે.",
    },
  },
  bhojanshala: {
    hero: {
      badge: "સાત્ત્વિક આહાર • પવિત્ર સેવા",
      brand: "ભોજનશાળા",
      title: "અન્નદાન સેવાનું સૌથી ઉમદા રૂપ છે",
      subtitle:
        "ભક્તો, યાત્રીઓ, વડીલ નાગરિકો અને મુલાકાતીઓ માટે શુદ્ધ અને પૌષ્ટિક ભોજન તથા આવશ્યક ભોજન સેવાઓનું પ્રાયોજન કરીને ભોજનશાળાને સહયોગ આપો.",
      primaryCta: "ભોજન પ્રાયોજન કરો",
      secondaryCta: "પ્રાયોજન વિકલ્પો જુઓ",
      imageAlt: "ભોજનશાળામાં પીરસાયેલું સાત્ત્વિક ભોજન થાળી",
    },
    about: {
      eyebrow: "પહેલ વિશે",
      heading: "ભોજનશાળા વિશે",
      tagline:
        "નિઃસ્વાર્થ રસોઈ અને ભક્તિ દ્વારા મન, શરીર અને આત્માનું પોષણ.",
      body: "ભોજનશાળા યાત્રીઓ, ભક્તો, વડીલ નાગરિકો અને મુલાકાતીઓને શુદ્ધ, સ્વચ્છ અને સાત્ત્વિક ભોજન પૂરું પાડે છે. દાતાઓ નવકારશી, બપોરનું ભોજન, રાત્રિ ભોજન, મીઠાઈ, ફરસાણ, ટિફિન સેવા, ફળ અને દૂધ સહિત વિવિધ ભોજન પ્રાયોજનો દ્વારા સહયોગ કરી શકે છે.",
    },
    schemes: {
      eyebrow: "લાંબા ગાળાના પ્રાયોજનો",
      heading: "કાયમી ભોજન પ્રાયોજન",
      subtitle: "૧૦ વર્ષ માટે કાયમી ભોજન તિથિ પ્રાયોજન વિકલ્પો.",
      sponsorNow: "હવે પ્રાયોજન કરો",
      lifetime: "આજીવન",
      empty: "પ્રાયોજન યોજનાઓ ટૂંક સમયમાં અહીં દેખાશે.",
    },
    packages: {
      eyebrow: "વ્યક્તિગત અને તહેવાર સેવાઓ",
      heading: "અન્ય ભોજન પ્રાયોજન વિકલ્પો",
      subtitle:
        "ભોજનશાળા માટે સંપૂર્ણ ભોજન દિવસ, તહેવાર ભોજન અથવા રજા સેવાનું પ્રાયોજન કરો.",
      sponsorship: "પ્રાયોજન",
      availableToday: "આજે ઉપલબ્ધ",
      nextAvailable: "આગળ ઉપલબ્ધ: આવતીકાલ",
      sponsorNow: "હવે પ્રાયોજન કરો",
      empty: "ભોજન પેકેજો ટૂંક સમયમાં અહીં દેખાશે.",
      colIndex: "#",
      colService: "સેવા",
      colDescription: "વર્ણન / શ્રેણી",
      colAmount: "રકમ",
      colAvailability: "ઉપલબ્ધતા",
      colAction: "ક્રિયા",
      popular: "લોકપ્રિય",
    },
    special: {
      eyebrow: "આહાર અને સમુદાય સમૃદ્ધિ",
      heading: "વિશેષ સેવા પ્રાયોજનો",
      subtitle:
        "વિશિષ્ટ વસ્તુઓ, આરોગ્ય માટે ફળ, સાંજનું ગરમ દૂધ અથવા વડીલો માટે ટિફિન પાર્સલ પૂરા પાડો.",
      availableToday: "આજે ઉપલબ્ધ",
      nextAvailable: "આગળ ઉપલબ્ધ: કાલે",
      sponsorNow: "હવે પ્રાયોજન કરો",
      empty: "વિશેષ સેવાઓ ટૂંક સમયમાં અહીં દેખાશે.",
    },
    note: {
      title: "મહત્વપૂર્ણ નોંધ",
      body: "વિશેષ મીઠાઈની વ્યવસ્થા માટેનું પ્રાયોજન રકમ અલગથી વસૂલવામાં આવશે.",
    },
    supporting: {
      badge: "સહાયક દાતા • સતત મદદ",
      heading: "ભોજનશાળા સહાયક દાતા બનો",
      body: "ભોજનશાળાની નિયમિત સેવાઓ, જાળવણી અને દૈનિક કામગીરી માટે સહાયક દાતા બનીને યોગદાન આપો.",
      contribution: "યોગદાન",
      amount: "₹9,000",
      amountLabel: "સતત યોગદાન",
      cta: "સહાયક દાતા બનો",
    },
    loading: "ભોજનશાળા વિકલ્પો લોડ થઈ રહ્યા છે…",
  },
};

export default programs;
